import { render } from "./StudentAttendanceList.vue?vue&type=template&id=7364ae19"
import script from "./StudentAttendanceList.vue?vue&type=script&lang=js"
export * from "./StudentAttendanceList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__